import { useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { selectRestockSubscribeData } from '@client/product/redux/restockSubscribe/redux';

export const useRestockSubscribeData = (): RemoteRecord<{ sku: number, email: string }> => (
  useSelector(selectRestockSubscribeData)
);
